import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'arrow'];

  toggle() {
    this.contentTarget.classList.toggle('collapsible-open');
    this.arrowTarget.classList.toggle('collapsible-arrow-open');
  }
}
